<header id="header" class="header">
  <div class="header-page bg-dark">
    <a class="toggle-offcanvas bg-dark" (click)="toggleNav()"><span></span></a>
    <h1 class="header-page-siteTitle">
      <a routerLink="/">Home</a>
    </h1>
  </div>
  <div class="header-page-authStatus">
    <span *ngIf="auth.loggingIn">Logging in...</span>
    <ng-template [ngIf]="!auth.loggingIn">
      <a *ngIf="!auth.loggedIn" (click)="auth.login()">Log In</a>
      <span *ngIf="auth.loggedIn && auth.userProfile">
        {{ auth.userProfile.name }}
        <span class="divider">|</span>
        <a (click)="auth.logout()">Log Out</a>
      </span>
    </ng-template>
  </div>
  <nav id="nav" class="nav" role="navigation">
    <ul class="nav-list">
      <li>
        <a
          class="btn btn-dark btn-block"
          routerLink="/"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">Home</a>
      </li>
      <li>
        <a
          class="btn btn-dark btn-block"
          routerLink="/contacts"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">Contacts</a>
      </li>
      <li class="nav-item">
        <a class="btn btn-dark btn-block" routerLink="/search" routerLinkActive="active">Search</a>
      </li>
    </ul>
  </nav>
</header>
